import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';

import Default from './Default';
import Readonly from './Readonly';

storiesOf('base', module).add('DeltaListItem', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>Delta List Item Component</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'DeltaListItem'}</Code> component accepts{' '}
          <Code>{'heading'}</Code>, <Code>{'subheading'}</Code>,{' '}
          <Code>{'total'}</Code>, <Code>{'delta'}</Code> and{' '}
          <Code>{'readonly'}</Code> props.
        </Text>
        <Spacer size={16} />
        <Text>
          The parent component determines the horizontal padding of{' '}
          <Code>{'DeltaListItem'}</Code> to allow for added flexibility.
        </Text>
      </Spacing>
    </FlexView>
    <Default />
    <Readonly />
  </ScrollView>
));
